import { Particle } from "../particle";
import { colorLerp, easeOut, lerp, linearMotion, randomBetween } from "../interpolation";

/**
 * Tiny bright yellow/white glints that appear briefly around gold piles.
 * Used as a continuous generator on higher-tier GoldDrops (tier 2-3).
 */
export class GoldSparkleParticle extends Particle {
	/** Emission interval for generators (ms between particles). */
	static readonly emitIntervalMs = 300;

	constructor(originX: number, originY: number) {
		const ttl = randomBetween(200, 400);

		// Tiny drift in a random direction
		const vx = randomBetween(-0.3, 0.3);
		const vy = randomBetween(-0.4, 0.1);

		const size = randomBetween(0.1, 0.2);

		// Randomize spawn position around the cell
		const ox = originX + randomBetween(-0.35, 0.35);
		const oy = originY + randomBetween(-0.35, 0.35);

		super(ox, oy, {
			ttl,
			size: lerp(size, size * 0.3),
			opacity: easeOut(0.9, 0.0),
			color: colorLerp(
				{ r: 255, g: 255, b: 220 }, // bright white-yellow
				{ r: 255, g: 200, b: 50 }, // warm gold
			),
			rotation: lerp(0, 0),
			position: linearMotion(vx, vy),
		});
	}
}
